import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0040"),
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group col-4 col-lg-2 pe-lg-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "referral-middle-initial" }, " M.I. ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Last_Name_Label",
  for: "referral-last-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge" }, "M0040"),
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A0810"),
  /*#__PURE__*/_createTextVNode(" Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Sex", -1 /* HOISTED */)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "DOB" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0066"),
  /*#__PURE__*/_createTextVNode(" Date of Birth "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "input-group date datepickerInput" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = { class: "form-group col-12 col-lg-8 pe-lg-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "referral-social-security-number" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0064"),
  /*#__PURE__*/_createTextVNode(" Social Security Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_22 = { class: "flex-grow-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "input-group-prepend flex" }
const _hoisted_25 = { class: "input-group-text form-check py-1 mb-0 rounded-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-2",
  for: "referral-ssn-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Unknown ")
], -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "referral-marital-status" }, " Marital Status ", -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select Marital Status", -1 /* HOISTED */)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_32 = { for: "referral-mobile-number" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Mobile Phone ")
const _hoisted_34 = { class: "fas fa-question-circle" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-phone" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "referral-email" }, " Email Address", -1 /* HOISTED */)
const _hoisted_42 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinical-manager" }, [
  /*#__PURE__*/_createTextVNode(" Clinical Manager "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Clinical Manager", -1 /* HOISTED */)
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinical-manager" }, [
  /*#__PURE__*/_createTextVNode(" Case Manager "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Case Manager", -1 /* HOISTED */)
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinical-manager" }, [
  /*#__PURE__*/_createTextVNode(" Assign To Clinical "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Assign To Clinician", -1 /* HOISTED */)
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "referral-email" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "(M0020)"),
  /*#__PURE__*/_createTextVNode(" Patient ID/MRN "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_56 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Agency_Branch_Label",
  for: "agency-location-id"
}, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinical-manager" }, [
  /*#__PURE__*/_createTextVNode(" Default Service Location "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_63 = ["value"]
const _hoisted_64 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_65 = { class: "col-12 py-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center sub-heading" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Primary Address")
  ])
], -1 /* HOISTED */)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-12 py-2" }
const _hoisted_69 = { class: "w-100" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center sub-heading" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Mailing Address")
], -1 /* HOISTED */)
const _hoisted_71 = { class: "form-check custom-checkbox form-check-inline mb-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sameprimarytomailing"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Primary Address")
], -1 /* HOISTED */)
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-12 py-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center sub-heading" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Visit Address")
  ])
], -1 /* HOISTED */)
const _hoisted_76 = {
  key: 0,
  class: "w-100"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label cursor-pointer btn btn-xs btn-outline-primary p-1",
  for: "visit-btn"
}, "+ ADD VISIT ADDRESS", -1 /* HOISTED */)
const _hoisted_78 = { class: "w-90" }
const _hoisted_79 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "mt-3 ai-validate-address-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Patient Information",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_First_Name",
                  name: "referral-first-name",
                  class: _normalizeClass(`form-control ${
                                        _ctx.v$.referral.Demographics.FirstName.$error ||
                                        _ctx.errors.Demographics.includes('FirstName')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter First Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Demographics.FirstName) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.FirstName.$touch && _ctx.v$.referral.Demographics.FirstName.$touch(...args))),
                  onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleAllInput(e, 'FirstName'))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.Demographics.FirstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-middle-initial",
                  class: "form-control",
                  maxlength: "1",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Demographics.MiddleInitial) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.MiddleInitial]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Last_Name",
                  name: "referral-last-name",
                  class: _normalizeClass(`form-control ${
                                        _ctx.v$.referral.Demographics.LastName.$error ||
                                        _ctx.errors.Demographics.includes('LastName')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  maxlength: "50",
                  placeholder: "Enter Last Name",
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.Demographics.LastName) = $event)),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.LastName.$touch && _ctx.v$.referral.Demographics.LastName.$touch(...args))),
                  onChange: _cache[6] || (_cache[6] = (e) => _ctx.handleAllInput(e, 'LastName'))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.Demographics.LastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Gender",
                  class: _normalizeClass(`form-select ${
                                        _ctx.v$.referral.Demographics.Gender.$error || _ctx.errors.Demographics.includes('Gender')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  name: "referral-gender",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.Demographics.Gender) = $event)),
                  onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.Gender.$touch && _ctx.v$.referral.Demographics.Gender.$touch(...args))),
                  onChange: _cache[9] || (_cache[9] = (e) => _ctx.handleAllInput(e, 'Gender'))
                }, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.gender, (gender, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: gender.text
                    }, _toDisplayString(gender.text), 9 /* TEXT, PROPS */, _hoisted_14))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.Gender]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("input", {
                        name: "DOB",
                        type: "text",
                        class: _normalizeClass(`form-control ${
                                                _ctx.v$.referral.Demographics.DOB.$error ||
                                                _ctx.errors.Demographics.includes('DOB')
                                                    ? 'border border-warning'
                                                    : ''
                                            }`),
                        placeholder: "MM/DD/YYYY",
                        autocomplete: "off",
                        value: _ctx.formatDateInput(_ctx.referral.Demographics.DOB),
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                        onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.DOB.$touch && _ctx.v$.referral.Demographics.DOB.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18),
                      _hoisted_19
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`input-group d-flex w-100 flex-nowrap ${
                                            _ctx.v$.referral.Demographics.SSN.$error || _ctx.errors.Demographics.includes('SSN')
                                                ? _ctx.isDuplicateSSN
                                                    ? 'border border-danger'
                                                    : 'border border-warning'
                                                : ''
                                        }`)
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        name: "referral-social-security-number",
                        maxlength: "9",
                        minlength: "9",
                        class: _normalizeClass(`form-control h-100 no-border-radius`),
                        type: "text",
                        placeholder: "Enter SSN",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.socialSecNumber) = $event)),
                        disabled: _ctx.referral.Demographics.SSNUnknown,
                        onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.SSN.$touch && _ctx.v$.referral.Demographics.SSN.$touch(...args))),
                        onChange: _cache[14] || (_cache[14] = (e) => _ctx.handleAllInput(e, 'SSN'))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_23), [
                        [_directive_number_only],
                        [_vModelText, _ctx.socialSecNumber]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "referral-ssn-na",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Demographics.SSNUnknown) = $event)),
                          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSSNUnknown()))
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.referral.Demographics.SSNUnknown]
                        ]),
                        _hoisted_26
                      ])
                    ])
                  ], 2 /* CLASS */)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  name: "marital-status",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.referral.Demographics.MaritalStatus) = $event))
                }, [
                  _hoisted_29,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.maritalStatus, (status, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: status.value
                    }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_30))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.Demographics.MaritalStatus]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("i", _hoisted_34, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, {
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`,
                                            placement: 'right'
                                        }]
                  ]),
                  _hoisted_35
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(`form-control phone-number-input ${
                                        _ctx.v$.referral.Demographics.PhonePreferred.$error ||
                                        _ctx.errors.Demographics.includes('PhonePreferred')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  maxlength: "10",
                  placeholder: "Enter Number",
                  onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setPhoneHome($event))),
                  value: _ctx.referral.Demographics.PhonePreferred,
                  onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.PhonePreferred.$touch && _ctx.v$.referral.Demographics.PhonePreferred.$touch(...args)))
                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_36), [
                  [_directive_number_only]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control phone-number-input",
                  maxlength: "10",
                  placeholder: "Enter Number",
                  onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setPhoneMobile($event))),
                  value: _ctx.referral.Demographics.PhoneAlternate
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_39), [
                  [_directive_number_only]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-email",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Email Address",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.referral.Demographics.EmailAddress) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.EmailAddress]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(`form-select  ${
                                        _ctx.v$.referral.Demographics.ClinicalManagerAssigned.$error ||
                                        _ctx.errors.Demographics.includes('ClinicalManagerAssigned')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.referral.Demographics.ClinicalManagerAssigned) = $event)),
                  onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.ClinicalManagerAssigned.$touch && _ctx.v$.referral.Demographics.ClinicalManagerAssigned.$touch(...args))),
                  onChange: _cache[24] || (_cache[24] = (e) => _ctx.handleAllInput(e, 'ClinicalManagerAssigned'))
                }, [
                  _hoisted_44,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.clinicalManager, (clinMngr, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: clinMngr.value
                    }, _toDisplayString(clinMngr.text), 9 /* TEXT, PROPS */, _hoisted_45))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.ClinicalManagerAssigned]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.referral.Demographics.CaseManagerId) = $event)),
                  class: _normalizeClass(`form-select  ${
                                        _ctx.v$.referral.Demographics.CaseManagerId.$error ||
                                        _ctx.errors.Demographics.includes('CaseManagerId')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.CaseManagerId.$touch && _ctx.v$.referral.Demographics.CaseManagerId.$touch(...args))),
                  onChange: _cache[27] || (_cache[27] = (e) => _ctx.handleAllInput(e, 'CaseManagerId'))
                }, [
                  _hoisted_48,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.caseManagerId, (caseManager, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: caseManager.value
                    }, _toDisplayString(caseManager.text), 9 /* TEXT, PROPS */, _hoisted_49))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.CaseManagerId]
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(`form-select  ${
                                        _ctx.v$.referral.Demographics.UserId.$error || _ctx.errors.Demographics.includes('UserId')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.referral.Demographics.UserId) = $event)),
                  onBlur: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.UserId.$touch && _ctx.v$.referral.Demographics.UserId.$touch(...args))),
                  onChange: _cache[30] || (_cache[30] = (e) => _ctx.handleAllInput(e, 'UserId'))
                }, [
                  _hoisted_52,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.userId, (user, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: user.value
                    }, _toDisplayString(user.text), 9 /* TEXT, PROPS */, _hoisted_53))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.UserId]
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-email",
                  class: _normalizeClass(`form-control  ${
                                        _ctx.v$.referral.Demographics.PatientIdNumber.$error ||
                                        _ctx.errors.Demographics.includes('PatientIdNumber')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter ID/MRN",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.referral.Demographics.PatientIdNumber) = $event)),
                  onBlur: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.PatientIdNumber.$touch && _ctx.v$.referral.Demographics.PatientIdNumber.$touch(...args))),
                  onChange: _cache[33] || (_cache[33] = (e) => _ctx.handleAllInput(e, 'PatientIdNumber'))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.Demographics.PatientIdNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Agency_Branch",
                  name: "agency-location-id",
                  class: _normalizeClass(`form-select  ${
                                        _ctx.v$.referral.Demographics.AgencyLocationId.$error ||
                                        _ctx.errors.Demographics.includes('AgencyLocationId')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.referral.Demographics.AgencyLocationId) = $event)),
                  onBlur: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.AgencyLocationId.$touch && _ctx.v$.referral.Demographics.AgencyLocationId.$touch(...args))),
                  onChange: _cache[36] || (_cache[36] = (e) => _ctx.handleAllInput(e, 'AgencyLocationId'))
                }, [
                  _hoisted_58,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: branch.id
                    }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_59))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.AgencyLocationId]
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(`form-select  ${
                                        _ctx.v$.referral.Demographics.ServiceLocation.$error ||
                                        _ctx.errors.Demographics.includes('ServiceLocation')
                                            ? 'border border-warning'
                                            : ''
                                    }`),
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.referral.Demographics.ServiceLocation) = $event)),
                  onBlur: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.ServiceLocation.$touch && _ctx.v$.referral.Demographics.ServiceLocation.$touch(...args))),
                  onChange: _cache[39] || (_cache[39] = (e) => _ctx.handleAllInput(e, 'ServiceLocation'))
                }, [
                  _hoisted_62,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.serviceLocation, (location, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: location.value
                    }, _toDisplayString(location.text), 9 /* TEXT, PROPS */, _hoisted_63))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Demographics.ServiceLocation]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_ReferralAddressForm, {
                address: _ctx.primaryAddress,
                "address-type": "PrimaryAddress",
                "address-name": "Primary Address",
                "county-data": _ctx.primaryCountyData,
                "show-code": true,
                isRequired: true,
                isCountyRequired: true,
                zipChanged: _ctx.getPrimaryCounty
              }, null, 8 /* PROPS */, ["address", "county-data", "zipChanged"])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "sameprimarytomailing",
                  class: "form-check-input au-target",
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.referral.Demographics.SameAsPhysicalAddress) = $event)),
                  onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isMailingSameAsPrimaryChanged()))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.Demographics.SameAsPhysicalAddress]
                ]),
                _hoisted_72
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_ReferralAddressForm, {
                address: _ctx.referral.Demographics.MailingAddress,
                "county-data": _ctx.mailingCountyData,
                "address-type": "MailingAddress",
                "show-code": false,
                isRequired: true,
                isCountyRequired: false,
                zipChanged: _ctx.handleMailingZipChange,
                "address-name": "Mailing Address"
              }, null, 8 /* PROPS */, ["address", "county-data", "zipChanged"])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            (!_ctx.referral.Demographics.IsVisitAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _withDirectives(_createElementVNode("input", {
                    hidden: "",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.referral.Demographics.IsVisitAddress) = $event)),
                    name: "visitaddrees",
                    id: "visit-btn",
                    value: true
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.referral.Demographics.IsVisitAddress]
                  ]),
                  _hoisted_77
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.referral.Demographics.IsVisitAddress)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("h6", _hoisted_79, [
                      _createElementVNode("button", {
                        class: "btn table-btn btn-outline-danger me-1 ms-auto",
                        onClick: _cache[43] || (_cache[43] = () => (_ctx.referral.Demographics.IsVisitAddress = false))
                      }, _hoisted_81)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createVNode(_component_ReferralAddressForm, {
                      address: _ctx.referral.Demographics.VisitAddress,
                      "county-data": _ctx.visitCountyData,
                      "address-type": "VisitAddress",
                      "show-code": false,
                      isCountyRequired: false,
                      zipChanged: _ctx.getVisitCounty,
                      "address-name": "Visit Address"
                    }, null, 8 /* PROPS */, ["address", "county-data", "zipChanged"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("button", {
              class: "button fr ai-validate-btn",
              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.validateAddress()))
            }, "Validate Addresses")
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}